export default __webpack_public_path__ + "static/media/img4.df893114.jpg";